import { Phone, MessageCircle, Zap } from "lucide-react";
import { contactInfo } from "@/data/machines";
import Reveal from "@/components/site/Reveal";

export default function CTABanner() {
  const waLink = `https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent(
    "Hola, necesito alquilar maquinaria hoy mismo. ¿Disponibilidad?"
  )}`;
  return (
    <section
      data-testid="cta-banner"
      className="py-20 md:py-24 relative overflow-hidden bg-gradient-to-br from-slate-950 via-[#0a1638] to-slate-900"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #38bdf8 0 12px, transparent 12px 28px)",
        }}
      />
      <div aria-hidden className="absolute -top-32 -right-32 w-[30rem] h-[30rem] bg-sky-500/25 blur-3xl rounded-full pointer-events-none animate-soft-pulse" />
      <div aria-hidden className="absolute -bottom-32 -left-32 w-[30rem] h-[30rem] bg-sky-400/10 blur-3xl rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          <Reveal>
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-sky-300 text-xs font-semibold uppercase tracking-wider">
                <Zap className="w-3.5 h-3.5 text-sky-400" />
                Entrega rápida en Toledo y alrededores
              </span>
              <h2 className="font-heading mt-4 text-3xl md:text-5xl font-bold tracking-tight text-white leading-[1.05]">
                ¿Necesitas maquinaria hoy mismo?
              </h2>
              <p className="mt-5 text-slate-300 text-base md:text-lg leading-relaxed">
                Llámanos o escríbenos por WhatsApp. Te confirmamos disponibilidad en minutos.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
              <a
                href={`tel:${contactInfo.phoneRaw}`}
                data-testid="cta-banner-call"
                className="group shine inline-flex items-center justify-center gap-2 bg-sky-500 hover:bg-sky-400 text-white font-semibold rounded-xl px-7 py-4 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-sky-500/30"
              >
                <Phone className="w-5 h-5 group-hover:wiggle" />
                <span className="text-base">Llamar ahora</span>
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-banner-whatsapp"
                className="group inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa55] text-white font-semibold rounded-xl px-7 py-4 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-emerald-500/25"
              >
                <MessageCircle className="w-5 h-5 transition-transform duration-300 group-hover:scale-110" />
                <span className="text-base">WhatsApp</span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
